import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import 'react-toastify/dist/ReactToastify.css';
import { API_URLS } from '../constants/apiUrl';
import { useLoading } from '../context/LoadingContext';
import { post } from '../api/api';
import { showToast } from '../components/utils/toast';

const generateCSRFToken = async () => {
  return post(API_URLS.CSRF_TOKEN);
};

export const useGenerateCSRFToken = (): UseMutationResult<
  { csrfToken: string },
  AxiosError<{ message?: string; type?: string }>
> => {
  const { setIsLoading } = useLoading();

  return useMutation({
    mutationFn: generateCSRFToken,
    onMutate: () => {
      setIsLoading(true);
    },
    onError: (error) => {
      showToast('error', error.message);
    },
    onSettled: () => {
      setIsLoading(false);
    },
  });
};
